import { Component, OnInit, TemplateRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Collection } from '../model/collection/collection';
import { UXControllerService } from '../service/controller/ux-controller.service';


@Component({
  selector: 'app-collection-search',
  templateUrl: './collection-search.component.html',
  styleUrls: ['./collection-search.component.css']
})
export class CollectionSearchComponent implements OnInit {
  @Input() sessionID;
  private collectionTyp = '';
  @Input() entityID;
  public activeEntityID: string = '12345678-1234-1234-1234-123456781234';
  public collItems: any;
  public collTypeItems = [
    { id: '', name: 'Collextiontyp wählen ...' },
    { id: 'a66ae04b-5f39-4782-921a-2cd3542b0b20', name: 'Attribute Sets' },
    { id: 'b12c0e38-cacb-4d50-9952-f82359e28532', name: 'Standard' },
    { id: '9e972e45-3e94-4878-b317-724cf2ea2b81', name: 'Import Collextion' }
  ];

  private collSearchText: string = '';
  private collPagerActivePage: number = 1;
  private selectedRowCol: number = -1;
  private opened: boolean = false;
  @ViewChild('collSearch') collSearch: TemplateRef<any>;
  @Output() collectionAction: EventEmitter<Collection> = new EventEmitter<Collection>();

  public modalRef: BsModalRef;
  private collection: Collection;

  constructor(
    private modalService: BsModalService,
    private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService
  ) { }

  ngOnInit() {
  }

  openCollectionSearch() {
    let search: string = '';
    this.collSearchText = '';
    this.selectedRowCol = -1;
    if (!this.opened) {
      if (this.collectionTyp != null && this.collectionTyp != "") search = "TypeDID = '" + this.collectionTyp + "'";
      this.cosyCommunicationControllerService.getAllCollection(this.sessionID, search, "[DisplayName] ASC", 5, 1, this.entityID).subscribe(
        coll => this.collItems = coll,
        error => console.error('ERROR: ', error),
        () => this.modalRef = this.modalService.show(this.collSearch)
      );
      this.cosyCommunicationControllerService.getContextKey(this.sessionID, "ActiveEntityID").subscribe(
        key => this.activeEntityID = key["value"],
        error => console.error('No ContextKey: ', error)
      );
      this.opened = true;
    }
    else this.modalRef = this.modalService.show(this.collSearch);
  }

  collSearchTextChange() {
    this.collPagerActivePage = 1;
    this.processSearchCollection();
  }

  setActiveRowCol(index) {
    this.selectedRowCol = index;
  };

  collPageChange(event: any): void {
    this.collPagerActivePage = event.page;
    this.processSearchCollection();
  }

  processSearchCollection() {
    document.body.style.cursor = "wait";
    let search: string = ''
    if (this.collectionTyp != null && this.collectionTyp != "" && this.collectionTyp == 'a66ae04b-5f39-4782-921a-2cd3542b0b20' && this.activeEntityID != '') {
      if (this.uxControllerService.primaryEntityID == 'bf22f335-8f80-491c-a5f6-a66808a69f96') search = "[DisplayName] like '%" + this.collSearchText + "%' AND TypeDID = '" + this.collectionTyp + "' AND EntityID = '" + this.activeEntityID + "'";
      else search = '';
    }
    else if (this.collectionTyp != null && this.collectionTyp != "" && this.collectionTyp != 'a66ae04b-5f39-4782-921a-2cd3542b0b20') search = "[DisplayName] like '%" + this.collSearchText + "%' AND TypeDID = '" + this.collectionTyp + "'";
    else search = "[DisplayName] like '%" + this.collSearchText + "%'";

    if (search != '') {
      this.cosyCommunicationControllerService.getAllCollection(this.sessionID, search, "[DisplayName] ASC", 5, this.collPagerActivePage, this.entityID).subscribe(
        coll => this.collItems = coll,
        error => { console.error('ERROR: ', error), document.body.style.cursor = "default"; },
        () => { document.body.style.cursor = "default"; }
      );
    }
    else {
      this.collItems = [];
      document.body.style.cursor = "default";
    }
  }

  addToCollection() {
    this.collection = new Collection();
    this.collection.collectionID = this.collItems['value'][this.selectedRowCol].ID;
    this.collection.action = 'add';
    this.collectionAction.emit(this.collection);
  }

}
